import { createReducer } from '../../store.model';

import { ActionType } from './form.action';
import { defaultState, FormState } from './form.state';
import {
    HidePublishConfirmDialog,
    ShowPublishConfirmDialog,
} from './state/dialog.action';
import {
    hidePublishConfirmDialogReducer,
    showPublishConfirmDialogReducer,
} from './state/dialog.reducer';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { Reset } from './state/reset.action';
import { resetReducer } from './state/reset.reducer';
import { Save, SaveResult } from './state/save.action';
import { saveReducer, saveResultReducer } from './state/save.reducer';

const { reducer, builder } = createReducer<ActionType, FormState>(
    defaultState(),
);

builder
    .add<Reload>(ActionType.EVAL_FORM__RELOAD, reloadReducer)
    .add<ReloadResult>(
        ActionType.EVAL_FORM__RELOAD_RESULT,
        reloadResultReducer,
    );

builder
    .add<Save>(ActionType.EVAL_FORM__SAVE, saveReducer)
    .add<SaveResult>(ActionType.EVAL_FORM__SAVE_RESULT, saveResultReducer);

builder
    .add<ShowPublishConfirmDialog>(
        ActionType.EVAL_FORM__SHOW_PUBLISH_CONFIRM_DIALOG,
        showPublishConfirmDialogReducer,
    )
    .add<HidePublishConfirmDialog>(
        ActionType.EVAL_FORM__HIDE_PUBLISH_CONFIRM_DIALOG,
        hidePublishConfirmDialogReducer,
    );

builder.add<Reset>(ActionType.EVAL_FORM__RESET, resetReducer);

export const formReducer = reducer;
